import React from 'react';
import Card from '@/components/card';
import Title from '@/components/title';
import { settingMenu } from '@/configs/menuItems';
import SubMenu from '@/components/menu/sub-menu';
import CompanyProfile from './components';
import { getPathSegment } from '@/utils/pathUtils';

const CompanySetting = () => {
  const pathSegment = getPathSegment();
  return (
    <>
      <SubMenu active={pathSegment} items={settingMenu} />
      <Card customClass="min-h-[200px]">
        <Title title="ข้อมูลบริษัท" />
        <CompanyProfile />
      </Card>
    </>
  );
};

export default CompanySetting;
